import * as React from 'react';
import './TrialAnalysisTypesPage.scss';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as TrialAnalysisTypeActions from '../../../actions/trialAnalysisTypes';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { TrialLookupsLayout } from '../../index';
interface ITrialAnalysisTypesPageProps {
  location: Location;
  history: History;

  // From state
  formFilter: IFormFilter;
  trialAnalysisType: Dtos.TrialAnalysisType[];
  loadingTrialAnalysisTypes: boolean;
  loadTrialAnalysisTypesSuccess: boolean;
  loadTrialAnalysisTypesFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles?: Dtos.RoleType[];
}
interface ITrialAnalysisTypesPageActions {
  clearTrialAnalysisTypes: TrialAnalysisTypeActions.ITrialAnalysisTypeClearActionCreator;
  loadTrialAnalysisTypes: TrialAnalysisTypeActions.ITrialAnalysisTypeLoadActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  filter: TrialAnalysisTypeActions.ITrialAnalysisTypeFilterActionCreator;
}
type TrialAnalysisTypesPageProps = ITrialAnalysisTypesPageProps & ITrialAnalysisTypesPageActions;
class TrialAnalysisTypesPage extends React.PureComponent<TrialAnalysisTypesPageProps, any> {
  constructor(props: TrialAnalysisTypesPageProps) {
    super(props);
    this.clearTrialAnalysisTypes = this.clearTrialAnalysisTypes.bind(this);
  }
  componentDidMount() {
    const {
      loadTrialAnalysisTypes
    } = this.props;
    loadTrialAnalysisTypes();
  }
  componentWillReceiveProps(nextProps: TrialAnalysisTypesPageProps) {}
  componentDidUpdate(prevProps: TrialAnalysisTypesPageProps, prevState) {
    const {
      navigateReplace
    } = this.props;
  }
  componentWillUpdate(nextProps: TrialAnalysisTypesPageProps) {}
  componentWillUnmount() {
    this.clearTrialAnalysisTypes();
  }
  clearTrialAnalysisTypes() {
    this.props.clearTrialAnalysisTypes();
  }
  showTrialAnalysisTypes(): boolean {
    const {
      loadingTrialAnalysisTypes,
      loadTrialAnalysisTypesSuccess
    } = this.props;
    if (!loadingTrialAnalysisTypes && loadTrialAnalysisTypesSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingTrialAnalysisTypes
    } = this.props;
    return <TrialLookupsLayout loading={loadingTrialAnalysisTypes} permission={Dtos.Permission.TrialAnalysisTypesView} data-sentry-element="TrialLookupsLayout" data-sentry-component="TrialAnalysisTypesPage" data-sentry-source-file="TrialAnalysisTypesPage.tsx">
            {this.renderContent()}
        </TrialLookupsLayout>;
  }
  renderContent() {
    const {
      permissions
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Trial Analysis Types</h2>
                </div>
                <div className="col-6" style={{
          textAlign: 'right'
        }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialAnalysisTypesCreate) && <Link className={"btn btn-primary"} url={"/settings/trial/trialAnalysisTypes/create"}>Create</Link>}
                </div>
            </div>
            {!this.showTrialAnalysisTypes() ? "Loading Trial Analysis Types" : null}
            {this.showTrialAnalysisTypes() ? <div className="patient-tables mt-2">
                        {this.createTable()}
                    </div> : null}
        </div>;
  }
  createTable() {
    const {
      trialAnalysisType
    } = this.props;
    if (!trialAnalysisType || trialAnalysisType.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no trial analysis types to view.</span>
            </div>;
    }
    const showPagination = trialAnalysisType.length > DEFAULT_PAGE_SIZE;
    return <div className="table-wrapper mb-3">
            <ReactTable data={trialAnalysisType} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : trialAnalysisType.length} pageSize={showPagination ? undefined : trialAnalysisType.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no trial analysis types to display" resizable={false} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            const url: string = "/settings/trial/trialAnalysisTypes/" + rowInfo.original.id;
            this.props.navigate(url);
            if (handleOriginal) {
              handleOriginal();
            }
          },
          style: {
            color: rowInfo && rowInfo.original && rowInfo.original.active ? '#212529' : '#9e9e9e'
          }
        };
      }} columns={[{
        id: "id",
        Header: ' ',
        accessor: "id",
        className: "d-flex align-items-center justify-content-center",
        maxWidth: 50,
        Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
      }, {
        id: "value",
        Header: 'Name',
        accessor: 'value',
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }]} />
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: TrialAnalysisTypesPageProps): ITrialAnalysisTypesPageProps => {
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    history: ownProps.history,
    location: state.routing.location,
    formFilter: state.trialAnalysisTypes.formFilter,
    trialAnalysisType: state.trialAnalysisTypes.formFilteredData,
    loadingTrialAnalysisTypes: state.trialAnalysisTypes.loadState && state.trialAnalysisTypes.loadState.status == RequestState.Pending,
    loadTrialAnalysisTypesSuccess: state.trialAnalysisTypes.loadState && state.trialAnalysisTypes.loadState.status == RequestState.Success,
    loadTrialAnalysisTypesFailure: state.trialAnalysisTypes.loadState && state.trialAnalysisTypes.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles
  };
};
const mapDispatchToProps = (dispatch): ITrialAnalysisTypesPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadTrialAnalysisTypes: bindActionCreators(TrialAnalysisTypeActions.LoadTrialAnalysisType, dispatch),
    clearTrialAnalysisTypes: bindActionCreators(TrialAnalysisTypeActions.Clear, dispatch),
    filter: bindActionCreators(TrialAnalysisTypeActions.Filter, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TrialAnalysisTypesPage);